// extracted by mini-css-extract-plugin
export default {"indexMain":"NotFound_indexMain__gFtJ8","label":"NotFound_label__-BZu9","logoImg":"NotFound_logoImg__P3d-u"};